export const STATUS = {
  ACCEPTED : 'accepted',
  PENDING  : 'pending',
  REJECTED : 'rejected',
  RETURNED : 'returned',
  REFUNDED : 'refunded'
}

export const INITIATED_BY = {
  OPS_BEFORE_SHIPPING : 'ops_before_shipping',
  CS                  : 'cs',
  CUSTOMER            : 'customer'
}

// Constant for person who be able to create Customer Refund Shipment
export const SHIPMENT_INITIATED_BY = {
  [INITIATED_BY.CUSTOMER.toUpperCase()] : INITIATED_BY.CUSTOMER,
  [INITIATED_BY.CS.toUpperCase()]       : INITIATED_BY.CS
}

export const BANK_NAME = {
  BCA     : 'BCA Bank Central Asia',
  BRI     : 'BRI Bank Rakyat Indonesia',
  BNI     : 'BNI Bank Negara Indonesia',
  MANDIRI : 'mandiri',
  OTHERS  : 'others'
}

export const REFUND_METHOD = {
  CASH         : 'cash',
  CREDIT_CARD  : 'credit_card',
  KREDIVO      : 'kredivo',
  GOPAY        : 'gopay',
  VOUCHER_CODE : 'voucher_code'
}

export const REASON = {
  EXPIRED_ITEM                : 'expired_item',
  COUNTERFEIT_ITEM_INDICATION : 'counterfeit_item_indication',
  MISSING_ITEM                : 'missing_item',
  DIFFERENT_FROM_WEBSITE      : 'different_from_website',
  DIFFERENT_ITEM_RECEIVED     : 'different_item_received',
  DEFECTIVE_ITEM              : 'defective_item',
  CHANGE_OF_MIND              : 'change_of_mind',
  SIZING                      : 'sizing',
  SOLD_BUT_LIVE               : 'sold_but_live',
  SOLD_BUT_LIVE_SCRAPER       : 'sold_but_live_scraper',
  QUALITY_DECREASE            : 'quality_decreases',
  SCRAPPING_TOO_LONG          : 'scrapping_too_long',
  SCRAPPING_SOLD_OUT          : 'scrapping_sold_out',
  SHIPPING_FEE                : 'shipping_fee',
  DIRTY_ITEM                  : 'dirty_item',
  RETUR_ITEM                  : 'retur_item',
  OTHERS                      : 'others'
}

export const SELLER_REASON = {
  [REASON.EXPIRED_ITEM]                : REASON.EXPIRED_ITEM,
  [REASON.COUNTERFEIT_ITEM_INDICATION] : REASON.COUNTERFEIT_ITEM_INDICATION,
  [REASON.DIFFERENT_FROM_WEBSITE]      : REASON.DIFFERENT_FROM_WEBSITE,
  [REASON.DIFFERENT_ITEM_RECEIVED]     : REASON.DIFFERENT_ITEM_RECEIVED,
  [REASON.DEFECTIVE_ITEM]              : REASON.DEFECTIVE_ITEM,
  [REASON.CHANGE_OF_MIND]              : REASON.CHANGE_OF_MIND,
  [REASON.SIZING]                      : REASON.SIZING,
  [REASON.QUALITY_DECREASE]            : REASON.QUALITY_DECREASE,
  [REASON.DIRTY_ITEM]                  : REASON.DIRTY_ITEM,
  [REASON.OTHERS]                      : REASON.OTHERS
}

export const RESOLUTION_ACTION = {
  PENDING               : 'pending',
  BACK_TO_LOCATION      : 'back_to_location',
  RETURN_TO_VENDOR      : 'return_to_vendor',
  SOLD_BUT_LIVE         : 'sold_but_live',
  SOLD_BUT_LIVE_SCRAPER : 'sold_but_live_scraper',
  RE_CURATE             : 're_curate',
  BOUGHT_BY_TL          : 'bought_by_tl',
  ITEM_WRONG_PRICE      : 'item_wrong_price',
  BACK_TO_WEBSITE       : 'back_to_website',
  RETURN_TO_BUYER       : 'return_to_buyer'
}

export const RESOLUTION_STATUS = {
  PENDING  : 'pending',
  COMPLETE : 'complete'
}


export const REJECT_REASON = {
  SALE_PRODUCT         : 'sale_product',
  EXCEED_REFUND_PERIOD : 'exceed_refund_period',
  NO_RETURN_ITEM       : 'no_return_item',
  INCOMPLETE_ATTRIBUTE : 'incomplete_attribute'
}
